import { createLog } from "../util/log";

const log = createLog("sheet");

export enum HcSheetView {
  FirstLevel = "first-level",
  SecondLevel = "second-level",
  SecondLevelNbf = "second-level-nbf",
  Navigation = "navigation",
}

interface HcSheetState {
  open: boolean;
  title: string;
  view: HcSheetView;
  secondLevelHeadline: string;
}

type Handler = () => void;

export const hcSheetState = $state<HcSheetState>({
  open: false,
  title: "",
  view: HcSheetView.FirstLevel,
  secondLevelHeadline: "",
});

export function isSecondLevelView(view: HcSheetView): boolean {
  return view !== HcSheetView.FirstLevel;
}

const handlers: { close?: Handler; back?: Handler } = {};

export function onHcSheetClose(handler: Handler): void {
  handlers.close = handler;
}

export function onHcSheetBack(handler: Handler): void {
  handlers.back = handler;
}

export function openHcSheet(title = ""): void {
  log.debug("sheet opened", { title });
  hcSheetState.title = title;
  hcSheetState.open = true;
}

export function markHcSheetClosed(): void {
  log.debug("sheet marked closed", { view: hcSheetState.view });
  hcSheetState.open = false;
}

export function setHcSheetSecondLevel(active: boolean, headline = "", nbf = false): void {
  hcSheetState.view = active ? (nbf ? HcSheetView.SecondLevelNbf : HcSheetView.SecondLevel) : HcSheetView.FirstLevel;
  hcSheetState.secondLevelHeadline = active ? headline : "";
  log.debug("sheet view changed", { view: hcSheetState.view, headline: hcSheetState.secondLevelHeadline });
}

export function setHcSheetNavigation(active: boolean, headline = ""): void {
  hcSheetState.view = active ? HcSheetView.Navigation : HcSheetView.FirstLevel;
  hcSheetState.secondLevelHeadline = active ? headline : "";
  log.debug("sheet view changed", { view: hcSheetState.view, headline: hcSheetState.secondLevelHeadline });
}

export function requestHcSheetClose(): void {
  if (handlers.close) {
    log.debug("sheet close requested");
    handlers.close();
  } else {
    log.warn("sheet close requested, but no close handler is registered, only marking the sheet closed");
    markHcSheetClosed();
  }
}

export function requestHcSheetBack(): void {
  if (!handlers.back) {
    log.warn("sheet back requested, but no back handler is registered, nothing happens");
    return;
  }
  log.debug("sheet back requested", { view: hcSheetState.view });
  handlers.back();
}
